module.exports = __webpack_public_path__ + "img/00011.e64a86b4.webp";